import React, { Component } from "react";
import { withRouter } from "../../components/withRouter";
import { addRole, editRoles } from "../../Path/Path";
import { toast } from "react-toastify";
import { TextField } from "@mui/material";
import { USER_ROLES } from "../../components/Helper";
import BackButton from "../../components/BackButton";
import { sanitizeStoreInput } from "../../helpers/validator";

// Permission configuration for each module
const PERMISSION_CONFIG = {
    HOME: [
        { value: "Home Dashboard", label: "Dashboard", alwaysChecked: true },
    ],
    ADMIN: [
        // { value: "Admin", label: "Admin" },
        // { value: "Admin Dashboard", label: "Admin Dashboard" },
        { value: "Users", label: "Users" },
        { value: "Devices", label: "Devices" },
        { value: "Stores", label: "Stores" },
        // { value: "AsnCancelation", label: "ASN Cancelation" },
        { value: "ZPL", label: "ZPL" },
        // { value: "Zones", label: "Zones" },
        { value: "Roles", label: "Roles" },
        { value: "Countries", label: "Countries" },
    ],
    COUNT: [
        { value: "Count Dashboard", label: "Count Dashboard"},
        { value: "Operation", label: "Operation" },
        { value: "Targeted Stock Count", label: "Targeted Stock Count" },
        { value: "Targeted Stock Summary", label: "Targeted Stock Summary" },
        { value: "Targeted Stock Operation", label: "Targeted Stock Operation" },
    ],
    TAGIT: [
        { value: "Tag IT", label: "Tag IT" },
        { value: "Printed Items", label: "Printed Items" },
        { value: "PO vs Printed", label: "PO vs Printed" },
        // { value: "Tag Printing", label: "Tag Printing" },
        // { value: "TO Printing", label: "TO Printing" },
        { value: "Bulk Printing", label: "Bulk Printing" },
        { value: "BoxLabelPrinting", label: "Box Label Printing" },
        { value: "BoxLabelPrintedItems", label: "Box Label Printed Items" },
    ],
    REPORTS: [
        { value: "Item Master", label: "Item Master" },
        { value: "Purchase Order Report", label: "Purchase Order Report" },
        { value: "Internal PO Report", label: "Internal PO Report" },
        { value: "PO Packing List Report", label: "PO Packing List Report" },
        { value: "PO Drill Down Report", label: "PO Drill Down Report" },
        { value: "Transfer Order Report", label: "Transfer Order Report" },
        { value: "SOH Report", label: "SOH Report" },
        { value: "Picking Report", label: "Picking Report" },
        { value: "PO Scanned Items Report", label: "PO Scanned Items Report" },
    ],
    SUPPLY_CHAIN: [
        { value: "Consignment", label: "Consignment" },
        { value: "PO Report", label: "PO Report" },
        { value: "To Report", label: "TO Report" },
    ],
};

class AddRole extends Component {
    constructor(props) {
        super(props)
        this.state = {
            permission: [],
            name: "",
        }
    }

    checkEvent = (e) => {
        const { checked, value } = e.target;
        if (!this.state.permission.includes(value) && checked === true) {
            this.setState({ permission: [...this.state.permission, value] })
        } else {
            this.setState({
                permission: this.state.permission.filter((elem) => {
                    return elem !== value;
                })
            })
        }
    }

    // Get all alwaysChecked permissions from config
    getAlwaysCheckedPermissions = () => {
        const allPermissions = [];
        Object.values(PERMISSION_CONFIG).forEach(section => {
            section.forEach(item => {
                if (item.alwaysChecked) {
                    allPermissions.push(item.value);
                }
            });
        });
        return allPermissions;
    }

    sendHandler = async () => {
        try {
        if (this.state.loading) return;
        this.setState({ loading: true });
        // Include always-checked permissions
        const alwaysChecked = this.getAlwaysCheckedPermissions();
        const allPermissions = [...new Set([...this.state.permission, ...alwaysChecked])];

        let body = {
            role_name: this.state.name.trim(),
            permissions: allPermissions
        }

        if (this.state.name === "" || this.state.name.trim().length < 2) {
            toast.warn("Enter role name and role name must be at least 2 characters")
        } else if (this.state.permission.length === 0 && alwaysChecked.length === 0) {
            toast.warn("Select permissions")
        } else if (this.props.location?.state?.item) {
            await editRoles(body, this.props.location?.state?.item._id)
            this.setState({ loading: false })
            this.props.history("/roles")
            toast.success("Role edit successfully")
        } else {
            await addRole(body)
            this.setState({ loading: false })
            toast.success("Role Added")
            this.props.history("/roles")
        }
        } catch (error) {
            this.setState({ loading: false })
            toast.error(error?.response?.data?.message || "Something went wrong")
        }
    }

    async componentDidMount() {
        if (this.props.location.state?.item) {
            const item = this.props.location.state.item
            this.setState({
                name: item.role_name,
                permission: item.permissions
            })
        }
    }

    renderPermissionSection = (title, permissions, sectionKey) => {

        return (
            <div className="permission-section" key={sectionKey}>
                <p className="all-para" style={{ marginTop: "10px" }}>{title}</p>
                <div className="all-checks">
                    {permissions?.map((item, index) => (
                        <div key={`${sectionKey}-${index}`} className='check'>
                            <input
                                type="checkbox"
                                checked={item.alwaysChecked || this.state.permission.includes(item.value)}
                                disabled={item.alwaysChecked}
                                name="permission"
                                id={item.value}
                                value={item.value}
                                onChange={(e) => this.checkEvent(e)}
                                style={item.alwaysChecked ? { cursor: "not-allowed" } : {}}
                            />
                            <label 
                                htmlFor={item.value} 
                                style={{ 
                                    color: item.alwaysChecked ? "#888" : "#fff", 
                                    fontWeight: "400", 
                                    marginTop: "8px", 
                                    marginLeft: "5px",
                                    cursor: item.alwaysChecked ? "not-allowed" : "pointer"
                                }}
                            >
                                {item.label}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="dashboard-main">
                <div className="dashboard-top">
                    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                        <BackButton />
                        <p className="stock-count" style={{ margin: 0 }}>{this.props.location?.state?.item ? "Edit Role" : "Add Role"}</p>
                    </div>
                </div>
                <div className="role-bottom">
                    <TextField
                        sx={{ width: 235 }}
                        defaultValue={this.state.name}
                        value={this.state.name}
                        placeholder="Role Name"
                        size={'small'}
                        onChange={(data) => this.setState({ name: sanitizeStoreInput(data.target.value) })}
                        id="outlined-basic"
                        label="Role Name"
                        variant="outlined"
                        error={this.state.name.trim().length > 0 && this.state.name.trim().length < 2}
                        helperText={
                            this.state.name.trim().length > 0 && this.state.name.trim().length < 2
                                ? 'Role name must be at least 2 characters'
                                : ''
                        }
                        inputProps={{ maxLength: 50 }}

                    />
                    <button className="run-btn clear-btn" onClick={() => this.setState({ name: "", permission: [] })}> <p className="run-text">Clear</p></button>
                </div>
                <div className="check-bottom">
                    <p className="check-para">User Permissions *</p>

                    {/* Home Section */}
                    {this.renderPermissionSection("Home", PERMISSION_CONFIG.HOME, "home")}

                    <div className="flex-role">
                        {/* Admin Section */}
                        <div className="admin-per">
                            {this.renderPermissionSection("Admin", PERMISSION_CONFIG.ADMIN, "admin")}
                        </div>

                        {/* Count Section */}
                        <div className="count-per">
                            {this.renderPermissionSection("Count", PERMISSION_CONFIG.COUNT, "count")}
                                </div>

                        {/* TagIT Section */}
                        <div className="Tagit-per">
                            {this.renderPermissionSection("TagIT", PERMISSION_CONFIG.TAGIT, "tagit")}
                        </div>

                        {/* Reports Section */}
                        <div className="Tagit-per">
                            {this.renderPermissionSection("Reports", PERMISSION_CONFIG.REPORTS, "reports")}
                                </div>

                        {/* Supply Chain Section */}
                        {/* <div className="rtv-per">
                            {this.renderPermissionSection("Supply Chain", PERMISSION_CONFIG.SUPPLY_CHAIN, "supply-chain")}
                        </div> */}

                        {/* Mobile Section */}
                        <div className="rtv-per">
                            <p className="all-para" style={{ marginTop: "10px" }}>Mobile</p>
                    <div className="all-checks">
                                {USER_ROLES.MOBILE?.map((item, index) => (
                                    <div key={`mobile-${index}`} className='check'>
                                <input
                                    type="checkbox"
                                    checked={this.state.permission.includes(item)}
                                    name="permission"
                                    id={item}
                                    value={item}
                                    onChange={(e) => this.checkEvent(e)}
                                />
                                <label htmlFor={item} style={{ color: "#fff", fontWeight: "400", marginTop: "8px", marginLeft: "5px" }}>
                                    {item}
                                </label>
                            </div>
                        ))}
                            </div>
                        </div>
                    </div>

                    <div className="role-btn" style={{ marginBottom: "20px", display: "flex", justifyContent: "center" }}>
                        <button className="run-btn" onClick={() => this.sendHandler()}>
                            <p className="run-text">{this.props.location?.state?.item ? "Edit Role" : "Add Role"}</p>
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AddRole);